module.exports = __webpack_public_path__ + "img/delete-01.a97db25f.svg";